/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import Raven          from "raven-js";
import configureRaven from "../lib/raven";
import boot           from "../lib/boot";
import "../lib/stimulus";
import migrateBootstrapDataAttributes from "../lib/migrateBootstrapDataAttributes";
import initClipboardDelegation from "../lib/clipboardDelegation";
import { initBootstrapTooltips, disposeBootstrapTooltipsIn } from "../lib/bootstrapTooltips";

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

function initNavbarDropdowns() {
  document.querySelectorAll('.navbar-main [data-bs-toggle="dropdown"]').forEach((el) => {
    if (!el.classList.contains("disabled") && !el.hasAttribute("disabled")) {
      bootstrap.Dropdown.getOrCreateInstance(el);
    }
  });
}

// Dropdowns inside .checklist are nested in the slick carousel which has overflow:hidden.
// Using strategy:'fixed' positions them relative to the viewport, bypassing that constraint.
function initChecklistDropdowns() {
  document.querySelectorAll('.checklist [data-bs-toggle="dropdown"]').forEach((el) => {
    if (!el.classList.contains("disabled") && !el.hasAttribute("disabled")) {
      bootstrap.Dropdown.getOrCreateInstance(el, { popperConfig: { strategy: 'fixed' } });
    }
  });
}

function afterDomReady() {
  // BS5 data API only recognizes data-bs-*; legacy markup uses data-toggle / data-target / data-dismiss.
  migrateBootstrapDataAttributes(document);
  initNavbarDropdowns();
  initChecklistDropdowns();
  initBootstrapTooltips(document);
  initClipboardDelegation();
}

document.addEventListener("turbolinks:load", afterDomReady);

document.addEventListener("turbolinks:before-cache", () => {
  disposeBootstrapTooltipsIn(document);
});

$(function() {
  afterDomReady();

  configureRaven();

  Raven.context(function() {
    boot.init()
  });
});
